import React from "react";
import currency from "currency.js";
import PropTypes from 'prop-types';
import { Constants } from '@shared';
import { Alerts } from "@common";

const BeginEnrollament = ({ invoice, next, alerts, dueDate }) => {

    const { total } = invoice;

    return (
        <div className="page-content-wrapper w-full gap-y-5">
            <h1 className="page-header">Let’s get started</h1>
            <span className="text-gray-500">You can always call Sunbound at <b>{Constants.Help.Phone}</b> or <a className="underline" href={Constants.Help.FAQ} target="_blank" rel="noreferrer">visit our FAQ</a> if you have any other questions.</span>
            <Alerts alerts={alerts} />

            <div className="content-box shadow-sb items-start">
                <div className="flex flex-col pl-5">
                    <span className="text-blue-text text-2xl">Rent Amount</span>
                    <span className="text-4xl tracking-wider">{currency(total).format()}</span>
                </div>
                <div className="flex flex-col pl-5">
                    <span className="text-blue-text text-2xl">Due Date</span>
                    <span className="text-4xl">{dueDate.toFormat(`DDD`)}</span>
                </div>
            </div>
            <button type="button" className="btn btn-primary mt-5" onClick={next}>Get Started</button>
        </div>
    );
};

BeginEnrollament.propTypes = {
    invoice: PropTypes.object.isRequired,
    next: PropTypes.func.isRequired,
    alerts: PropTypes.array,
    dueDate: PropTypes.string.isRequired
};

export default BeginEnrollament;

